import React from 'react';
import PropTypes from 'prop-types';

import ContactSelect from './select';
import ContactFormModal from 'bundles/backoffice/contacts/forms/modal';

export default class ContactSelector extends React.Component {
  static propTypes = {
    allowTagging: PropTypes.bool,
    autoFocus: PropTypes.bool,
    className: PropTypes.string,
    contact: PropTypes.object,
    contactType: PropTypes.string,
    disabled: PropTypes.bool,
    menuPlacement: PropTypes.string,
    modalBackdrop: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    newContactVisibility: PropTypes.string,
    requestPermissions: PropTypes.bool,
    showQuickbooks: PropTypes.bool,
    styles: PropTypes.object,
    onChange: PropTypes.func.isRequired
  }

  state = {}

  showCreateContactModal = (query) => {
    this.setState({ showCreateContactModal: true, newContactName: query });
  }

  hideCreateContactModal = () => {
    this.setState({ showCreateContactModal: false });
  }

  handleModalSave = (contact) => {
    this.handleChange(contact, true);
  }

  handleSelectChange = (contact) => {
    this.handleChange(contact, false);
  }

  handleChange = (contact, newContact) => {
    if (contact && !contact.id) {
      contact.id = contact.associatedModelId;
    }

    if (contact && !contact.contactType) {
      contact.contactType = contact.associatedModelType;
    }

    this.props.onChange(contact, newContact);
    this.hideCreateContactModal();
  }

  render() {
    return <>
      <ContactSelect
        autoFocus={this.props.autoFocus}
        className={this.props.className}
        contact={this.props.contact}
        disabled={this.props.disabled}
        limitToType={this.props.contactType}
        menuPlacement={this.props.menuPlacement}
        styles={this.props.styles}
        onChange={this.handleSelectChange}
        onCreateClick={this.showCreateContactModal}
      />

      <ContactFormModal
        allowTagging={this.props.allowTagging}
        backdrop={this.props.modalBackdrop}
        contactType={this.props.contactType}
        initialName={this.state.newContactName}
        newContactVisibility={this.props.newContactVisibility}
        requestPermissions={this.props.requestPermissions}
        showQuickbooks={this.props.showQuickbooks}
        show={this.state.showCreateContactModal}
        onCancel={this.hideCreateContactModal}
        onSave={this.handleModalSave}
      />
    </>;
  }
}
